import { apiClient } from './apiClient';

class ChatGPTService {
  handleAuthError(response) {
    if (response.status === 401) {
      // Redirect to login
      window.location.href = `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`;
      throw new Error('Not authenticated');
    }
  }

  async generateStructuredTranscript(role, type, language, transcript) {
    try {
      const data = await apiClient.post('/api/chatgpt/generate', {
        role,
        type,
        language,
        transcript
      });

      if (!data || !data.structuredTranscript) {
        throw new Error('Invalid response format from server');
      }

      return data.structuredTranscript;
    } catch (error) {
      console.error('Error generating structured transcript:', error);
      throw error;
    }
  }

  async translateText(text, targetLanguage) {
    try {
      const data = await apiClient.post('/api/chatgpt/translate', {
        text,
        targetLanguage
      });

      if (!data || !data.translation) {
        throw new Error('Invalid response format from server');
      }

      return data.translation;
    } catch (error) {
      console.error('Translation error:', error);
      throw error;
    }
  }

  async improveTranscript(originalText, newTranscript, role, language, tab, selection = null) {
    try {
      const data = await apiClient.post('/api/chatgpt/improve-transcript', {
        originalText,
        newTranscript,
        role,
        language,
        tab,
        selection
      });

      if (!data || !data.improvedTranscript) {
        throw new Error('Invalid response format from server');
      }

      return data.improvedTranscript;
    } catch (error) {
      console.error('Error improving transcript:', error);
      throw error;
    }
  }

}

const chatGPTServiceInstance = new ChatGPTService();
export default chatGPTServiceInstance; 